import { Seller } from '../seller';
export class Resource {
    constructor(
        public id?: number,
        public file?: any,
        public seller?: Seller,
        public fileName?: string
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/resource/resource.model.ts